import { HttpErrorResponse } from '@angular/common/http';
import {
  GetAttachmentUrlResponse,
  RemittanceFile,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const PayOnAccountSelectPaymentMethodEmailActions = createActionGroup({
  source: 'POA Select Payment Method Component Email',
  events: {
    'Get Attachment Url Success': props<GetAttachmentUrlResponse>(),
    'Get Attachment Url Error': props<{
      fileName: string;
      emailSendDate: string;
      error: HttpErrorResponse;
    }>(),
    'Upload Attachment Success': props<{
      attachmentUrlResponse: GetAttachmentUrlResponse;
      remittanceFile: RemittanceFile;
    }>(),
    'Upload Attachment Error': props<{
      fileName: string;
      emailSendDate: string;
      error: HttpErrorResponse;
    }>(),
  },
});
